import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8f94646"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
      'drop-down__item',
      { ganhemais: _ctx.item.name === 'Meus treinamentos' && _ctx.isCirculoTemplate() }
    ]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToRoute && _ctx.goToRoute(...args)))
  }, [
    _createElementVNode("img", {
      width: "20",
      height: "20",
      src: require(`../../../../assets/static/main-menu/${_ctx.item.image}`),
      alt: "Ícone"
    }, null, 8, _hoisted_1),
    _createTextVNode(" " + _toDisplayString(_ctx.item.name), 1)
  ], 2))
}